module.exports = __webpack_public_path__ + "img/247money-logo.e6286344.svg";